<template>
    <v-card class="elevation-1 rounded-4"> 
        <v-toolbar flat height="45px">
            <span class="font-weight-bold">{{ popupTitle }}</span>
            <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
            <v-layout row wrap class="form-cotent">
                <v-flex xs12>
                    <p v-html="msg" :class="alignLeft?'msg-text-left':''"></p>
                    <v-textarea v-model="comments" label="Add remarks (optional)" rows="1" color="primary"></v-textarea>
                </v-flex>
            </v-layout>
            
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn title="Ok" class="primary" dark @click="ok" :loading="loading">{{ okButtonLabel }}</v-btn>
            <v-btn title="Cancel" @click="closeDialog">Cancel</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>

export default {
    data () {
        return {
            loading: false,
            comments: null
        }
    },
    props:['msg', 'alignLeft', 'title', 'okLabel'],
    methods: {
        ok() {
            this.closeDialog()
            this.$emit('ok', this.comments)
        },
        closeDialog() {
            this.$emit('update:dialogOkCancel2', false)
        },
    },
    computed: {
        popupTitle() {
            return this.title ? this.title : 'Confirm'
        },
        okButtonLabel() {
            return this.okLabel ? this.okLabel : 'Ok'
        }
    },
}
</script>
<style scoped>
.form-cotent {
    margin:10px 20px 10px 20px;
}
.msg-text-left {
    text-align: left;
}
</style>